import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-back-to-top',
  templateUrl: './back-to-top.component.html',
  styleUrls: ['./back-to-top.component.scss'],
})
export class BackToTopComponent implements OnInit {
  @Input() target: string;

  constructor() {}

  ngOnInit() {}

  scrollToTarget(): void {
    const target = document.querySelector('#' + this.target);
    target.scrollIntoView({
      block: 'start',
      inline: 'nearest',
      behavior: 'smooth',
    });
  }
}
